import { useEffect } from 'react';

/**
 * A React hook to prompt the user before they leave the page.
 * This is useful for preventing data loss in forms.
 *
 * @param when A boolean condition to enable or disable the prompt.
 * @param message The message to show in the confirmation dialog (for older browsers).
 */
const useBeforeUnload = (when: boolean, message: string) => {
  useEffect(() => {
    const handleBeforeUnload = (event: BeforeUnloadEvent) => {
      if (when) {
        event.preventDefault();
        // This is required for legacy browsers.
        // Modern browsers show a generic message for security reasons.
        event.returnValue = message;
        return message;
      }
      return;
    };

    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, [when, message]); // Re-run the effect if 'when' or 'message' changes
};

export default useBeforeUnload;
